import React, { Component } from 'react';

import { USER_ROLE_RENTER } from 'common/userRoles';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK } from 'client/analytics/eventList';

import { SCREEN_ID_MAINTENANCE } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import Navbar from '../components/Navbar';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_RENTER,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_MAINTENANCE)
@withScrollToTop
class MaintenancePage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: 'Maintenance',
    // canonical: '/',
    // keywords: 'some, keywords',
    // description: 'Site description here.',
  })

  _onTextExpertButtonClick = () => {
    analytics.track(ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK);
  }

  render() {
    return (
      <div className='page-faq'>
        <div className='maintenance'>
          <Navbar />

          <div className='faq'>

            <div className='questionsContainer'>
              <span className='headline'>Site Temporarily Under&nbsp;Maintenance</span>
              <span className='subheader'>
                Sorry for the inconvenience, we are doing maintenance on our system.
              </span>

              <span className='question'>Can I still find rentals through Sunroom?</span>
              <span className='answer'>
                Yes,
                <span className='italics'> text Zac at (512) 423-4723</span>
                . We will text you rentals that match your search criteria!
              </span>
            </div>
          </div>

          <div className='mainContainer'>

            <span className='headline'>Text me questions</span>

            <div className='agent header clearfix'>
              <div className='avatar' />
              <div className='description'>
                <span className='name'>Zac M.&nbsp;&nbsp;&nbsp;|
                  <span className='title'>
                    &nbsp;&nbsp;Sunroom Tour Guide
                  </span>
                </span>
                <span className='rating'>
                  <span className='reviewCount'>Austin / Round Rock</span>
                </span>
              </div>
            </div>

            <span className='bodyText'>
              If you have questions about a home or apartment, send me a text.
              I can call the landlord on your behalf, schedule tours, process your
              application and also provide general rental hunting tips.
              <br />
              <br />
              Feel free to link me rentals you find on other sites.
              I’ll make sure you get to tour the home whenever you want!
            </span>
            <a href='sms:+15127143550' onClick={this._onTextExpertButtonClick} className='button blue'>
              <span className='prompt'>text zac </span>
              <span className='normal'>(512) 423-4723</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

MaintenancePage.displayName = 'MaintenancePage';

export default MaintenancePage;
